import React, { useState } from "react";
import Bluedart from "../../../assets/bluedart.png";
import Delehivery from "../../../assets/delehivery.png";
import EcomExpress from "../../../assets/ecom-expresss.avif";
import Shadowfax from "../../../assets/shadowfax.png";
import Xpressbees from "../../../assets/xpressbees.png";
import Shiprocket from "../../../assets/shiprocket.webp";
import NimbusPost from "../../../assets/nimbuspost.webp";
import ShreeMaruti from "../../../assets/shreemaruti.png";
import DTDC from "../../../assets/dtdc.png";
import Amazon from "../../../assets/amazon.jpg";
import { Link } from "react-router-dom";
import { FaTruck, FaPlane, FaInfoCircle } from "react-icons/fa";
import ThreeDotLoader from "../../../Loader";

const carrierLogos = {
  Bluedart,
  Delhivery: Delehivery,
  EcomExpress,
  Shadowfax,
  Xpressbees,
  NimbusPost,
  Shiprocket,
  ShreeMaruti,
  DTDC,
  Amazon,
};

const displayValue = (v) => (v === undefined || v === null || v === "" ? "-" : v);

const ChargeBreakdownModal = ({ open, onClose, details }) => {
  if (!open || !details) return null;
  const working = details.working || {};
  console.log(details)
  const topRows = [
  {
    label: "Recipient City",
    value: `${displayValue(details?.working?.recipient_city)}`,
  },
  {
    label: "Sender City",
    value: `${displayValue(details?.working?.sender_city)}`,
  },
  {
    label: "Recipient Zone",
    value: `${displayValue(details?.working?.recipient_location_type)} (${displayValue(details?.working?.recipient_zone)})`,
  },
  {
    label: "Sender Zone",
    value: `${displayValue(details?.working?.sender_location_type)} (${displayValue(details?.working?.sender_zone)})`,
  },
];

  console.log(topRows);

const rows = [
  { label: "Chargeable Wt.", value: working.chargeable_weight ? `${working.chargeable_weight} kg` : "-" },
  { label: "Rate", value: working.rate != null ? `₹${working.rate}` : "-" },
  { label: "Freight", value: working.freight != null ? `₹${working.freight}` : "-" },
  { label: "Handling Charges", value: working.handling_charges != null ? `₹${working.handling_charges}` : "-" },
  { label: "ODA", value: working.oda != null ? `₹${working.oda}` : "-" },
  { label: "FSC", value: working.fsc != null ? `₹${working.fsc}` : "-" },
  { label: "AWB Charges", value: working.awb_charges != null ? `₹${working.awb_charges}` : "-" },
  { label: "ROV", value: working.rov != null ? `₹${working.rov}` : "-" },
  { label: "Total (before GST)", value: working.total != null ? `₹${working.total}` : "-" },
  { label: "GST", value: working.gst != null ? `₹${working.gst}` : "-" },
  { label: "Estimated Grand Total", value: working.grand_total != null ? `₹${working.grand_total}` : "-" }
];


  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-full max-w-md p-6 relative shadow-lg z-50">
        <h2 className="text-lg font-bold mb-2 text-gray-700">Rate Calculation</h2>
        <div className="mb-3 grid grid-cols-2 gap-2 text-xs text-gray-700">
          {topRows.map((r, idx) => (
            <div key={idx} className="flex flex-col mb-1">
              <span className="font-semibold">{r.label}</span>
              <span>{r.value}</span>
            </div>
          ))}
        </div>
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <tbody>
              {rows.map((r, idx) => (
                <tr key={idx}>
                  <td className="pr-2 py-1 text-gray-600 whitespace-nowrap">{r.label}</td>
                  <td className="font-semibold py-1 text-right text-gray-700">{r.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button className="mt-4 w-full bg-[#0CBB7D] text-white rounded py-2 font-bold" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

const CourierRateSelection = ({ plan, loading, hasFetched }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState(null);

  const openModal = (details) => {
    setModalDetails(details);
    setModalOpen(true);
  };
  const closeModal = () => setModalOpen(false);

  if (hasFetched && (!Array.isArray(plan) || plan.length === 0)) {
    return <p className="text-center py-4 text-gray-600">No Data Found</p>;
  }

  if (hasFetched && loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <ThreeDotLoader />
      </div>
    );
  }

  return (
    <>
      <ChargeBreakdownModal open={modalOpen} onClose={closeModal} details={modalDetails} />
      {!hasFetched && plan.length > 0 && (
        <div>
          {/* Desktop View */}
          <div className="hidden md:block bg-white shadow rounded-lg p-4">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b text-left bg-[#0CBB7D] text-white font-[600] text-[12px]">
                    <th className="px-3 py-2">Courier</th>
                    <th className="px-3 py-2 text-center">Mode</th>
                    <th className="px-3 py-2 text-center">Charges</th>
                    <th className="px-3 py-2 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {plan
                    .slice()
                    .sort((a, b) => (a.rate || 0) - (b.rate || 0))
                    .map((item, index) => (
                      <tr
                        key={item.id || item.courierServiceName || index}
                        className="border-b text-gray-700 text-[12px]"
                      >
                        <td className="flex items-center space-x-4 px-3 py-2">
                          <img
                            src={
                              carrierLogos[
                                item.provider.split(" ")[0].replace(/[^a-zA-Z]/g, "") || ""
                              ] || Shadowfax
                            }
                            alt={item.courierServiceName}
                            className="w-12 h-12"
                          />
                          <span>{item.courierServiceName}</span>
                        </td>
                        <td className="text-center px-3 py-2">
                          <div className="flex justify-center">
                            {item.mode === "air" ||
                            item.details?.mode_name?.toLowerCase() === "air" ||
                            item.mode_name?.toLowerCase() === "air" ? (
                              <FaPlane className="text-gray-500 text-[18px]" />
                            ) : (
                              <FaTruck className="text-gray-500 text-[18px]" />
                            )}
                          </div>
                        </td>
                        <td className="text-center font-[600] px-3 py-2 text-gray-500">
                          ₹{item.rate}
                          <button
                            type="button"
                            className="ml-2 text-[#0CBB7D] align-middle"
                            title="Show Charge breakdown"
                            onClick={() => openModal(item.details)}
                          >
                            <FaInfoCircle className="inline-block" />
                          </button>
                        </td>
                        <td className="text-center px-3 py-2">
                          <Link to="/dashboard/order/neworder">
                            <button className="px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] font-[600]">
                              + Create Shipment
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile View */}
          <div className="md:hidden bg-white rounded-lg mt-[-20px] sm:p-4">
            {plan.map((item, index) => (
              <div
                key={item.id || item.courierServiceName || index}
                className="bg-white shadow-md rounded-lg p-4 mb-4"
              >
                <div className="flex items-center space-x-4">
                  <img
                    src={
                      carrierLogos[
                        item.provider.split(" ")[0].replace(/[^a-zA-Z]/g, "") || ""
                      ] || Shadowfax
                    }
                    alt={item.courierServiceName}
                    className="w-12 h-12"
                  />
                  <div>
                    <h2 className="text-[10px] font-[600] text-gray-700">
                      {item.courierServiceName}
                    </h2>
                  </div>
                </div>
                <div className="mt-2 space-y-2">
                  <div className="flex justify-between">
                    <p className="text-[10px] font-[600] text-gray-500">Mode</p>
                    <div>
                      {item.mode === "air" ||
                      item.details?.mode_name?.toLowerCase() === "air" ? (
                        <FaPlane className="text-gray-500 text-[12px]" />
                      ) : (
                        <FaTruck className="text-gray-500 text-[12px]" />
                      )}
                    </div>
                  </div>
                  <div className="flex justify-between font-[600] text-gray-500 items-center text-[10px]">
                    <span>Charges</span>
                    <span className="flex items-center">
                      ₹{item.rate}
                      <button
                        type="button"
                        className="ml-2 text-[#0CBB7D]"
                        title="Show Charge breakdown"
                        onClick={() => openModal(item.details)}
                      >
                        <FaInfoCircle />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="mt-2 flex justify-center">
                  <Link to="/dashboard/order/neworder">
                    <button className="w-full bg-[#0CBB7D] text-white rounded-lg py-2 font-semibold text-[10px]">
                      + Create Shipment
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CourierRateSelection;
